import React from "react";
import { services } from "../../services";
import { PaymentRequest } from "@iibf/shared-resources/models/db";
import usePromise from "../../utils/hooks/usePromise";
import { APIError } from "../../services/request";
import { User } from "../Home";
import { Link } from "react-router-dom";

export function UserListActionsFragment(props: { row: User }) {
  const { run: downloadReceipt, loading: downloadingReceipt } = usePromise(
    {
      fn: async () => {
        try {
          const paymentRequests = await services.requestSvc.get<
            PaymentRequest[]
          >("/get-payment-requests-by-learner-id?learnerId=" + props.row.id);
          const successPR = paymentRequests.find(
            (e) => e.transactionStatus === "SUCCESS"
          )!;

          if (!successPR.invoiceUrl)
            return alert(
              "The Invoice hasn't been generated for this payment request yet"
            );

          const { signedUrl } = await services.requestSvc.post<{
            signedUrl: string;
          }>("/get-file-signed-url", {
            fileUrl: successPR.invoiceUrl,
          });

          console.log("Signed URL", signedUrl);

          window.open(signedUrl, "_blank");
        } catch (err) {
          console.log(err);
          alert(
            err instanceof APIError ? err.message : "An unknown error occurred"
          );
        }
      },
    },
    [props.row.id]
  );

  return (
    <div className="flex items-center gap-x-2 justify-center">
      <button
        className="btn-link"
        onClick={downloadReceipt}
        disabled={downloadingReceipt}
      >
        {downloadingReceipt ? "Downloading..." : "Download receipt"}
      </button>{" "}
      |
      <Link to={props.row.highestQualificationFile.downloadUrl}>
        <button className="btn-link">
          Download Highest Qualification Certificate
        </button>
      </Link>{" "}
      |
      <Link to={props.row.identityProofFile.downloadUrl}>
        <button className="btn-link">Download Identity Proof</button>
      </Link>{" "}
      |
      <Link to={props.row.candidatePhotoFile.downloadUrl}>
        <button className="btn-link">Download Candidate Photo</button>
      </Link>{" "}
      |
      <Link to={props.row.candidateSignatureFile.downloadUrl}>
        <button className="btn-link">Download Candidate Signature</button>
      </Link>
    </div>
  );
}
